import React from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { useStoreState } from 'base/store';
import { Link } from '@base/lib/Link';
import { FeatureContainer } from 'mod/featureV2/FeatureContainer';
import { IFeatureBase, IFeatureProps } from 'mod/featureV2/interface';
import { ThemeSwiper } from '@base/lib/ThemeSwiper';
import { ITopPromotionBar } from 'base/interfacesV2/feature';
import Iconfont from '@base/lib/Iconfont';
import { getModuleCode } from 'base/utils/features';
import Tracker, { ITrackerData } from '@base/lib/Tracker';

type ListItemListItemProps = {
    item: ITopPromotionBar['banner'][number];
    trackData: ITrackerData;
}

const ListItem: React.FC<ListItemListItemProps> = props => {
    const { item, trackData } = props;
    return (
        <Tracker data={trackData}>
            <div className={cn('ctr-middle', styles.item)}>
                <Link href={item.bannerUrl} className={styles['text-wrap']}>
                    <Iconfont className={item.iconClassName}/>
                    {item.bannerText}
                </Link>
            </div>
        </Tracker>
    )
}

export default function FeatureBenefitsPC(props: IFeatureProps<IFeatureBase>): Globals.JSXRenderType {
    const { topPromotionBar: config } = useStoreState('persistStore');
    if (!config || !config.banner?.length) {
        return null;
    }
    const list = config.banner;

    const getTrackData = (item: ITopPromotionBar['banner'][number], index: number) => {
        return {
            module: getModuleCode({ moduleId: props.feature.moduleId || '' }),
            targetType: 'other',
            target: item.bannerUrl || item.bannerText,
            relTarget: item.bannerUrl || item.bannerText,
            position: index + 1
        }
    }

    return (
        <FeatureContainer {...props} className={styles.benefits}>
            <div className={styles.list}>
                <div className="flex wrapper-large">
                    {list.map((item, index) => (
                        <ListItem
                            key={item.bannerText}
                            item={item}
                            trackData={getTrackData(item, index)}
                        />
                    ))}
                </div>
            </div>

            <ThemeSwiper
                className={cn(styles.swiper, styles['pc-swiper'])}
                direction="vertical"
                loop
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                list={list}
                render={(item, index) => (
                    <ListItem
                        item={item}
                        trackData={getTrackData(item, index)}
                    />
                )}
            />

        </FeatureContainer>
    )
}